import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";

import "./button-action.scss";

const ButtonAction = ({
  icon,
  iconPosition = "right",
  dataTip,
  textButton,
  loading,
  textLoadingButton,
  wrapperStyles,
  className,
  handlerClick,
  disabled,
  typeButton = "default",
}) => {
  return (
    <div className={wrapperStyles}>
      <button
        type="button"
        data-tip={dataTip}
        className={`${className || "button-action-container"} ${typeButton} ${
          disabled && "disabled"
        }`}
        onClick={loading ? null : handlerClick}
        disabled={disabled}
      >
        {icon && iconPosition === "right" && (
          <span className="link">
            <FontAwesomeIcon icon={icon} />
          </span>
        )}

        {loading && typeButton !== "icon-only" ? (
          <span className="text-button">{textLoadingButton}</span>
        ) : (
          <span className="text-button">{textButton}</span>
        )}

        {icon && iconPosition === "left" && (
          <span className="link">
            <FontAwesomeIcon icon={icon} />
          </span>
        )}
      </button>
      {dataTip && (
        <ReactTooltip
          className="tooltipMessage"
          place="bottom"
          effect="solid"
          type="light"
        />
      )}
    </div>
  );
};

ButtonAction.defaultProps = {
  icon: "",
  iconPosition: "right",
  dataTip: "",
  textButton: "",
  loading: false,
  textLoadingButton: "",
  wrapperStyles: "",
  className: "",
  disabled: false,
  typeButton: "default",
};

ButtonAction.propTypes = {
  icon: PropTypes.string,
  iconPosition: PropTypes.oneOf(["right", "left"]),
  dataTip: PropTypes.string,
  textButton: PropTypes.string,
  wrapperStyles: PropTypes.string,
  className: PropTypes.string,
  handlerClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  typeButton: PropTypes.oneOf(["default", "line", "icon-only"]),
  loading: PropTypes.bool,
  textLoadingButton: PropTypes.string,
};

export default ButtonAction;
